const ConnorsTheme = {
  black: "#050505",
  red: "#512ACC",
  redDark: "#3E1FA8",
  redLight: "rgba(81, 42, 204, 0.1)",
  redMuted: "rgba(81, 42, 204, 0.14)",
  white: "#ffffff",
  backgroundGrey: "#f5f5f5",
  fallbackGradient:
    "radial-gradient(ellipse at 15% 100%, rgba(76, 33, 207, 0.8) 0%, rgba(76, 33, 207, 0) 50%), radial-gradient(ellipse at 85% 100%, rgba(100, 50, 255, 0.4) 0%, rgba(100, 50, 255, 0) 50%)",
};

export default ConnorsTheme;
